import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { PrivacyPolicyContent } from '../components/legal/LegalModals';

/* ─────────────────────────────────────────────────────────────────────────────
   PrivacyPolicyPage — public, no-login-required page for Google Play's Data
   Safety form "Privacy Policy" link (api.safer-sdn.com/privacy-policy).
   Renders the same PrivacyPolicyContent shown in-app as a modal, but as a
   directly-loadable page — Play Console review requires a URL that shows the
   policy without any click/JS-state interaction, which the modal alone
   couldn't satisfy.
───────────────────────────────────────────────────────────────────────────── */
const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div dir="rtl" className="min-h-screen bg-[#F5F9FF] py-8 px-4">
      <div className="w-full max-w-2xl mx-auto bg-white rounded-2xl shadow-[0_4px_24px_rgba(7,30,82,.10)] border border-[#E5E7EB] overflow-hidden">
        <div className="flex items-center gap-2.5 px-6 py-5 border-b border-gray-100">
          <span className="w-9 h-9 rounded-lg bg-[#EEF2FF] text-[#0A4D9D] flex items-center justify-center flex-shrink-0">
            <Lock size={18} />
          </span>
          <h1 className="text-lg font-black text-gray-900">سياسة الخصوصية</h1>
        </div>

        <div className="px-6 py-6 space-y-4 text-sm text-gray-700 leading-relaxed">
          <PrivacyPolicyContent />
        </div>

        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50">
          <button
            onClick={() => navigate('/')}
            className="text-sm font-bold text-[#0A4D9D] hover:underline"
          >
            العودة إلى سافر
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
